<template>
<div class="pageContainer">
  <div class="summaryContainer">
    <div class="summary">
      <h1 class="summary-header">
        <div class="summary-symbol">
          {{ note.title }}
        </div>
        <div class="summary-toolbar">
          <router-link :to="'/note/'+$route.params.name+'/edit'"
            class="summary-edit">
            <i class="i">edit</i>
            Edit
          </router-link>
        </div>
      </h1>
    </div>
  </div>

  <div class="stock-text markdown-text" v-html="this.body"></div>
</div>
</template>

<script>
import Note from '../helpers/Note';
import marked from 'marked';

export default {
  data(){ return{
    note: {}
  }},

  methods: {

  },

  computed: {
    body(){ return marked(this.note.body || '') }
  },

  mounted(){
    Note.get(this.$route.params.name).then(snapshot => {
      this.note = snapshot.val();
    });
  },

  beforeRouteUpdate(to, from, next) {
    Note.get(to.params.name).then(snapshot => {
      this.note = snapshot.val();
      next();
    });
  }
}
</script>



// WEBPACK FOOTER //
// noteview.vue?05f708f0